// <lex-logo size="40" wordmark="true|false" sub="true|false"></lex-logo>
// Logo oficial ZZYON (Brand Manual v1.0) com ponto-órbita bronze (família LEX).
// Adaptado de torre-shared/components/zzy-logo.js — mantém proporções do lockup oficial.
class LexLogo extends HTMLElement {
  static get observedAttributes() { return ['size', 'sub', 'wordmark']; }
  connectedCallback() { this.render(); }
  attributeChangedCallback() { this.render(); }
  render() {
    const size = parseInt(this.getAttribute('size') || '40', 10);
    const showSub = this.getAttribute('sub') !== 'false';
    const showWord = this.getAttribute('wordmark') !== 'false';

    const wordSize = Math.round(size * 0.58);
    const subSize  = Math.max(9, Math.round(size * 0.26));
    const gap      = Math.max(10, Math.round(size * 0.34));

    this.innerHTML = `
      <span style="display:inline-flex;align-items:center;gap:${gap}px;color:currentColor;font-family:'Inter',system-ui,sans-serif">
        <svg viewBox="0 0 200 200" width="${size}" height="${size}" aria-label="ZZYON LEX" style="flex-shrink:0">
          <circle cx="100" cy="100" r="88" fill="none" stroke="currentColor" stroke-width="9"/>
          <path d="M 54 54 L 144 54 L 60 100 L 144 100 L 60 146 L 144 146"
                fill="none" stroke="currentColor" stroke-width="12" stroke-linecap="square"/>
          <circle cx="178" cy="52" r="8" fill="#8C6B3F"/>
        </svg>
        ${showWord ? `
          <span style="display:inline-flex;flex-direction:column;line-height:1">
            <span style="font-size:${wordSize}px;font-weight:800;letter-spacing:0.02em;color:currentColor">
              ZZYON
            </span>
            ${showSub ? `
              <span style="font-size:${subSize}px;font-weight:700;letter-spacing:0.32em;color:#8C6B3F;margin-top:4px">
                LEX
              </span>
            ` : ''}
          </span>
        ` : ''}
      </span>
    `;
  }
}
if (!customElements.get('lex-logo')) {
  customElements.define('lex-logo', LexLogo);
}
